import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge classifies a `text-*` utility by its value: it recognizes the
 * default font-size scale and treats any other word as a text color. A custom
 * `--text-*` theme step is therefore invisible to it as a size, so a color
 * class on the same element drops the step and the component's own `text-sm`
 * survives in its place. Register every custom font-size step here — see
 * `apps/platform-marketing/app/globals.css` for the steps these names come
 * from.
 */
const twMerge = extendTailwindMerge({
  extend: { classGroups: { "font-size": [{ text: ["label", "control"] }] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
